import {
	Header,
	FaFolder,
	AppEnum,
	OptionHelper,
	PermissionEnums,
	FaUser,
} from "@/Shared";
import { ResourceAccessViewModel } from "./ViewModels/ResourceAccessViewModel";

/**
 * Configuration des colonnes pour la vue des documents.
 */
export class ResourceAccessHeader {
	private constructor() {}

	getResource(ResourceTypeEnum : AppEnum[]) {
		return {
			key: "resource",
			icon: <FaFolder />,
			label: "Resource",
			type: "string",
			isSortable: true,
			filter: {
				label: "Resource",
				case: "insensitive",
				options : OptionHelper.sortByLabel(ResourceTypeEnum)
			},
		};
	}

	get allRecords() {
		return {
			key: "allRecords",
			icon: <FaUser />,
			label: "Toutes Données",
			type : "string",
			isSortable: true,
		}
	}

	get write() {
		return {
			key: "write",
			icon: <FaUser />,
			label: "Ecrire",
			type : "string",
			isSortable: true,
		}
	}

	get read() {
		return {
			key: "read",
			icon: <FaUser />,
			label: "Lire",
			type : "string",
			isSortable: true,
		}
	}

	get delete() {
		return {
			key: "delete",
			icon: <FaUser />,
			label: "Supprimer",
			type : "string",
			isSortable: true,
		}
	}

	get restore() {
		return {
			key: "restore",
			icon: <FaUser />,
			label: "Restaurer",
			type : "string",
			isSortable: true,
		}
	}

	get execute() {
		return {
			key: "execute",
			icon: <FaUser />,
			label: "Executer",
			type : "string",
			isSortable: true,
		}
	}

	get export() {
		return {
			key: "export",
			icon: <FaUser />,
			label: "Exporter",
			type : "string",
			isSortable: true,
		}
	}

	get audit() {
		return {
			key: "audit",
			icon: <FaUser />,
			label: "Auditer",
			type : "string",
			isSortable: true,
		}
	}

	
	static build(
		viewEnums: PermissionEnums
	): Record<keyof ResourceAccessViewModel, Header<ResourceAccessViewModel>> {
		const header = new ResourceAccessHeader();

		return {
			resource: header.getResource(viewEnums.ResourceTypeEnum),
			allRecords : header.allRecords,
			write : header.write,
			read : header.read,
			delete : header.delete,
			restore : header.restore,
			export : header.export,
			execute : header.execute,
			audit : header.audit,
			

		} as Record<keyof ResourceAccessViewModel, Header<ResourceAccessViewModel>>;
	}
}
